import { SelectItem } from "../../types/SelectItem";
import { RentalProduct } from "../enums";

export function getPrepayPenaltySelects(product: string) {
  if (
    product === RentalProduct["10/1 ARM"] ||
    product === RentalProduct.Fixed
  ) {
    return selectPrepayPenaltyFixed;
  }
  return selectPrepayPenalty;
}

export const selectRentalProduct: SelectItem[] = [
  { label: "5/1 ARM", value: "5/1 ARM" },
  { label: "10/1 ARM", value: "10/1 ARM" },
  { label: "5 IO 25 ARM", value: "5 IO 25 ARM" },
  { label: "Fixed", value: "Fixed" },
];

export const selectBuyUpBuyDown: SelectItem[] = [
  { label: "Rate Buy Up", value: "Rate Buy Up" },
  { label: "Rate Buy Down", value: "Rate Buy Down" },
  { label: "No Buy Up/Buy Down", value: "No Buy Up/Buy Down" },
];

export const selectPrepayPenalty: SelectItem[] = [
  {
    label: "3 Year Prepayment Penalty: 1, 1, 1",
    value: "3 Year Prepayment Penalty: 1, 1, 1",
  },
  {
    label: "3 Year Prepayment Penalty: 3, 2, 1",
    value: "3 Year Prepayment Penalty: 3, 2, 1",
  },
  {
    label: "3 Year Prepayment Penalty: 5, 5, 5",
    value: "3 Year Prepayment Penalty: 5, 5, 5",
  },
  {
    label: "5 Year Prepayment Penalty: 5, 4, 3, 2, 1",
    value: "5 Year Prepayment Penalty: 5, 4, 3, 2, 1",
  },
  {
    label: "7 Year Prepayment Penalty: 5, 5, 4, 4, 3, 2, 1",
    value: "7 Year Prepayment Penalty: 5, 5, 4, 4, 3, 2, 1",
  },
  {
    label: "No Prepayment",
    value: "No Prepayment",
  },
];

export const selectPrepayPenaltyFixed: SelectItem[] = [
  {
    label: "3 Year Prepayment Penalty: 1, 1, 1",
    value: "3 Year Prepayment Penalty: 1, 1, 1",
  },
  {
    label: "3 Year Prepayment Penalty: 3, 2, 1",
    value: "3 Year Prepayment Penalty: 3, 2, 1",
  },
  {
    label: "3 Year Prepayment Penalty: 5, 5, 5",
    value: "3 Year Prepayment Penalty: 5, 5, 5",
  },
  {
    label: "5 Year Prepayment Penalty: 5, 4, 3, 2, 1",
    value: "5 Year Prepayment Penalty: 5, 4, 3, 2, 1",
  },
  {
    label: "7 Year Prepayment Penalty: 5, 5, 4, 4, 3, 2, 1",
    value: "7 Year Prepayment Penalty: 5, 5, 4, 4, 3, 2, 1",
  },
  {
    label: "No Prepayment",
    value: "No Prepayment",
  },
];

export const selectPrepayPenaltyBridge: SelectItem[] = [
  {
    label: "No Prepayment",
    value: "No Prepayment",
  },
];

export const rateBuyDownSelects: SelectItem[] = [
  { label: "0", value: 0 },
  { label: "0.25", value: 0.25 },
  { label: "0.50", value: 0.5 },
];
